import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_HOST } from "../api_utils";
import { Box, Divider, Modal } from "@mui/material";
import Loader from "../Shared_Components/Loader";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
// import { RiSave2Fill } from "react-icons/ri";

function Home(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [cnnyList, setCnnyList] = useState([]);

  const [editPass, setEditPass] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
    _id: "",
  });
  const [currentYear, setCurrentYear] = useState("");
  const [showEditChineseYear, setShowEditChineseYear] = useState(false);
  const [newChineseDate, setNewChineseDate] = useState("");
  const [noCNYFound, setNoCNYFound] = useState(false);
  const [reportDate, setReportDate] = useState("");
  const [isNewYear, setIsNewYear] = useState(false);

  let navigate = useNavigate();

  const updatePasswordByAdminHandler = async () => {
    setLoading(true);
    if (
      editPass.new_password &&
      editPass.confirm_password &&
      editPass.current_password
    ) {
      if (editPass.new_password === editPass.confirm_password) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userDataFromStorage.token}`,
          },
        };

        const data = await axios.put(
          `${API_HOST}/api/users/change_password`,
          editPass,
          config
        );
        if (data) {
          if (data.status === 200) {
            setLoading(false);
            toast.success(data.data.message);
            setPasswordModalOpen(false);
          } else {
            setLoading(false);
            toast.error(data.data.message);
          }
        } else {
          setLoading(false);
          toast.error("Something Went Wrong !!!");
        }
      } else {
        setLoading(false);
        toast.warn("New Password And Confirm Password Do Not Match !!!");
      }
    } else {
      setLoading(false);
      toast.warn("Make Sure To Fill All Fields !!!");
    }
  };

  var options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Singapore", // Set the time zone to Singapore
  };

  const getCnnyStartDateHandler = async () => {
    const { data } = await axios.get(
      `${API_HOST}/api/users/get_cnny_start_date`
    );
    if (data) {
      if (!data.message) {
        console.log("data::::", data);
        const dbDate = new Date(data[0].cn_ny_start);

        let singaporeDate = new Date(
          Date.UTC(
            dbDate.getUTCFullYear(),
            dbDate.getUTCMonth(),
            dbDate.getUTCDate()
          )
        );

        console.log("singaporeDate:::::::", singaporeDate);

        // Adjust for any time zone offset
        // const adjustedDate = new Date(
        //   dbDate.getTime() + dbDate.getTimezoneOffset() * 60000
        // );

        // // Convert the adjusted date to Singapore time zone
        // const singaporeDate = adjustedDate.toLocaleDateString("en-SG", options);

        setReportDate(singaporeDate);
      }
    }
  };

  function setToMidnight(date) {
    console.log("date111111111", date);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    console.log("date::::::::::::", date);
    return date;
  }

  function isCurrentDateFirstJanuary() {
    const currentDate = new Date();
    const firstJanuary = new Date(currentDate.getFullYear(), 0, 1); // Month is zero-based

    // Set time to midnight for both dates to compare only the date part
    currentDate.setHours(0, 0, 0, 0);
    firstJanuary.setHours(0, 0, 0, 0);

    console.log("currentDate.getMonth()", currentDate.getMonth());
    console.log("currentDate.getDate()", currentDate.getDate());
    console.log("firstJanuary.getMonth()", firstJanuary.getMonth());
    console.log("firstJanuary.getDate()", firstJanuary.getDate());

    if (
      currentDate.getMonth() === firstJanuary.getMonth() &&
      currentDate.getDate() === firstJanuary.getDate()
    ) {
      return setIsNewYear(true);
    }
  }

  useEffect(() => {
    isCurrentDateFirstJanuary();
  }, []);

  useEffect(() => {
    getCnnyStartDateHandler();
  }, []);

  useEffect(() => {
    let timer = 0;
    if (!userDataFromStorage?.last_login_date) {
      timer = setTimeout(() => {
        // Your code to be executed after 5 seconds
        setPasswordModalOpen(true);
      }, 2000);
    }

    // Clean up the timer to prevent memory leaks
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (reportDate) {
      console.log("reportDate:::::::", reportDate);

      let singaporeDateNew = new Date(reportDate);

      // Set time to midnight for reportDate and current date
      const midnightReportDate = setToMidnight(singaporeDateNew);
      console.log("midnightReportDate:::", midnightReportDate);
      const midnightCurrentDate = setToMidnight(new Date());

      // Compare the dates
      if (midnightReportDate.getTime() > midnightCurrentDate.getTime()) {
        setIsNewYear(true);
      }
    }
  }, [reportDate, isNewYear]);

  // const defaultedLoansHandler = async () => {
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${userDataFromStorage.token}`,
  //     },
  //   };

  //   const payload = {
  //     defaulted_loans_check: true,
  //   };
  //   const { data } = await axios.post(
  //     `${API_HOST}/api/loan_header/default_loan_check`,
  //     payload,
  //     config
  //   );

  //   if (data) {
  //     console.log("data", data);
  //   }
  // };

  // useEffect(() => {
  //   defaultedLoansHandler();
  // }, []);

  const updateChineseNewYearHandler = async () => {
    if (newChineseDate) {
      const startYear = new Date(newChineseDate).getFullYear();
      console.log("startYear", startYear);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const payload = {
        start_date: newChineseDate,
        start_year: startYear,
      };
      const { data } = await axios.post(
        `${API_HOST}/api/cnny_start/update_cnny_start`,
        payload,
        config
      );
      if (data) {
        if (data.message === "cnny start date updated successfully !!!") {
          toast.success("Chinese New Year is updated successfully!!!");
          setShowEditChineseYear(false);
        } else {
          toast.error("Something went wrong!!!");
        }
      }
    }
  };

  const addChineseNewYearHandler = async () => {
    if (newChineseDate) {
      const startYear = new Date(newChineseDate).getFullYear();
      console.log("startYear", startYear);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const payload = {
        cn_ny_start: newChineseDate,
        cn_ny_year: startYear,
      };
      const { data } = await axios.post(
        `${API_HOST}/api/cnny_start/update_cnny_start`,
        payload,
        config
      );
      if (data) {
        if (data.message === "cnny start date updated successfully !!!") {
          toast.success("Chinese New Year is updated successfully!!!");
          setShowEditChineseYear(false);
        } else {
          toast.error("Something went wrong!!!");
        }
      }
    }
  };

  const processAllAndUpdate = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    const payload = {
      process_all: false,
      token: userDataFromStorage.token,
    };

    const data = await axios.post(
      `${API_HOST}/api/users/process_all_change`,
      payload,
      config
    );
    if (!data.mesage) {
      console.log("data:::::::::", data);
      sessionStorage.setItem("user", JSON.stringify(data.data));
    }
  };

  useEffect(() => {
    if (userDataFromStorage && userDataFromStorage.process_all_date) {
      console.log("userDataFromstorage::::::", userDataFromStorage);

      // Extract day, month, and year from the stored date
      const storedDate = userDataFromStorage.process_all_date.split("T")[0];
      const [storedYear, storedMonth, storedDay] = storedDate
        .split("-")
        .map(Number);

      const today = new Date();
      const storedYear1 = today.getFullYear();
      const storedMonth1 = today.getMonth();
      const storedDay1 = today.getDate();

      // Create a Date object with the extracted components
      const storedDateObject = new Date(storedYear, storedMonth - 1, storedDay);
      const storedDateObject1 = new Date(storedYear1, storedMonth1, storedDay1);

      console.log("storedDateObject1::::::", storedDateObject1);
      console.log("storedDateObject::::::", storedDateObject);

      // Compare dates
      if (storedDateObject < storedDateObject1) {
        console.log("here::::::");
        processAllAndUpdate();
      }
    }
  }, []);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%] xl:h-[83vh] h-[90vh] md:h-[87vh] lg:h-[78vh]  xl:mt-[8%] mt-[20%] bg-sky-50 "
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[4%] mt-[20%]  bg-sky-50 xl:h-[93vh]"
      }>
      {userDataFromStorage.user_role === "admin" ? (
        <>
          {!showEditChineseYear && !noCNYFound ? (
            <>
              {" "}
              <p className="lg:text-[2rem] text-gray-700 text-[1.2rem] md:text-[1.5rem]  font-Roboto ">
                Welcome to Microloan System
              </p>
              <p className="lg:text-lg font-Roboto mt-[0.2rem] mb-[0.3rem] md:mb-[0.7rem] md:mt-[0.7rem] text-gray-600">
                You are logged in as {userDataFromStorage?.login_name}
              </p>
              <p className="lg:text-lg font-Roboto text-gray-600">
                Please select your action from the menus above
              </p>
              <p className="text-[0.8rem] mt-4 font-Roboto text-gray-600">
                Reporting cut off for the New Year is{" "}
                {reportDate
                  ? new Date(reportDate).toLocaleDateString("en-GB")
                  : ""}
              </p>
              {/*isNewYear ? (
                <button
                  onClick={() => setShowEditChineseYear(true)}
                  style={{ backgroundColor: coloredTheme }}
                  className="text-white font-Roboto px-8 py-3 rounded-lg mt-4">
                  Change Date ?
                </button>
              ) : (
                ""
              )*/}
              <button
                onClick={() => setShowEditChineseYear(true)}
                style={{ backgroundColor: coloredTheme }}
                className="text-white font-Roboto px-8 py-3 rounded-lg mt-4">
                Change Date ?
              </button>
            </>
          ) : showEditChineseYear && !noCNYFound ? (
            <>
              <p className="lg:text-[2rem] text-gray-700 text-[1.2rem] md:text-[1.5rem]  font-Roboto ">
                Set Chinese New Year
              </p>
              <p className="text-[0.8rem] mt-4 font-Roboto text-gray-600">
                Enter the date at which you will start the reporting and loans
                refresh after Chinese New Year
              </p>
              <div className="w-[100%] flex justify-start items-center space-x-6 mt-4">
                <label className=" font-Roboto text-gray-600">
                  Chinese New Year refresh start date
                </label>
                <input
                  type="date"
                  value={newChineseDate}
                  onChange={(e) => setNewChineseDate(e.target.value)}
                  className="flex-grow rounded-lg p-[0.5rem] font-Roboto text-gray-600 underline-none border border-gray-500"
                />
              </div>
              <div className="flex justify-between items-center">
                <button
                  onClick={() => updateChineseNewYearHandler()}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-start items-center mt-8 space-x-2 px-8 py-3 rounded-lg text-white">
                  <RiSave2Fill />
                  <p>Save</p>
                </button>
                <button
                  onClick={() => setShowEditChineseYear(false)}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-start items-center mt-8 space-x-2 px-8 py-3 rounded-lg text-white">
                  Cancel
                </button>
              </div>
            </>
          ) : !showEditChineseYear && noCNYFound ? (
            <>
              <p className="lg:text-[2rem] text-gray-700 text-[1.2rem] md:text-[1.5rem]  font-Roboto ">
                Set Chinese New Year
              </p>
              <p className="text-[0.8rem] mt-4 font-Roboto text-gray-600">
                Enter the date at which you will start the reporting and loans
                refresh after Chinese New Year
              </p>
              <div className="w-[100%] flex justify-start items-center space-x-6 mt-4">
                <label className=" font-Roboto text-gray-600">
                  Chinese New Year refresh start date
                </label>
                <input
                  type="date"
                  value={newChineseDate}
                  onChange={(e) => setNewChineseDate(e.target.value)}
                  className="flex-grow rounded-lg p-[0.5rem] font-Roboto text-gray-600 underline-none border border-gray-500"
                />
              </div>
              <div className="flex justify-between items-center">
                <button
                  onClick={() => addChineseNewYearHandler()}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-start items-center mt-8 space-x-2 px-8 py-3 rounded-lg text-white">
                  <RiSave2Fill />
                  <p>Save</p>
                </button>
                <button
                  onClick={() => setShowEditChineseYear(false)}
                  style={{ backgroundColor: coloredTheme }}
                  className="flex justify-start items-center mt-8 space-x-2 px-8 py-3 rounded-lg text-white">
                  Cancel
                </button>
              </div>
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        <div>
          <p className="lg:text-[2rem] text-gray-700 text-[1.2rem] md:text-[1.5rem]  font-Roboto ">
            Welcome to Microloan System
          </p>
          <p className="lg:text-lg font-Roboto  mb-[0.3rem] md:mb-[0.7rem] md:mt-[0.7rem] text-gray-500">
            You are logged in as {userDataFromStorage?.login_name}
          </p>
          <p className="text-gray-500 text-[0.8rem] ">
            Please Select Your Action Below
          </p>

          {/* MANAGER ACTION PANEL */}
          {userDataFromStorage.user_role === "manager" ? (
            <div className="flex justify-center items-center flex-col mt-[2rem]">
              <button
                onClick={() => navigate("/customers/overview")}
                className="flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Customers
              </button>
              <button
                onClick={() => navigate("/products")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Loan Products
              </button>
              <button
                onClick={() => navigate("/claims")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Claims
              </button>
              <button
                onClick={() => navigate("/loans")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Loans
              </button>
              <button
                onClick={() => navigate("/reports/my_stamp_duty")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                My Stamp Duty
              </button>
              <button
                onClick={() => navigate("/users")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Agents
              </button>
              <button
                onClick={() => navigate("/reports/profit_share")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Profit Sharing
              </button>
              <button
                onClick={() => navigate("/start_of_day")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Start Of Day
              </button>
              <button
                onClick={() => navigate("/collections")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Collections Report
              </button>
              <button
                onClick={() => navigate("/cash/cash_count")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Cash In Hand
              </button>
              <button
                onClick={() => navigate("/reports/cash_flow")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Cash Flow
              </button>
              <button
                onClick={() => navigate("/reports/transaction_report")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Transaction Reports
              </button>
              <button
                onClick={() => navigate("/reports/stamp")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Stamp Duty Reports
              </button>
              <button
                onClick={() => navigate("/reports/profit_report")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Profitability Reports
              </button>
              <button
                onClick={() => navigate("/reports/defaulted_loan")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Defaulted Loans
              </button>
            </div>
          ) : userDataFromStorage.user_role === "agent" ? (
            <div className="flex justify-center items-center flex-col mt-[2rem]">
              <button
                onClick={() => navigate("/start_of_day")}
                className="flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Start Of Day
              </button>
              <button
                onClick={() => navigate("/collections")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Collections Report
              </button>
              <button
                onClick={() => navigate("/cash/cash_count")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Cash In Hand
              </button>
              <button
                onClick={() => navigate("/reports/my_stamp_duty")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                My Stamp Duty
              </button>
              <button
                onClick={() => navigate("/loans")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Loans
              </button>
              <button
                onClick={() => navigate("/customers/overview")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Customers
              </button>
              <button
                onClick={() => navigate("/claims")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Make A Claim
              </button>
            </div>
          ) : userDataFromStorage.user_role === "senior_agent" ? (
            <div className="flex justify-center items-center flex-col mt-[2rem]">
              <button
                onClick={() => navigate("/start_of_day")}
                className="flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Start Of Day
              </button>
              <button
                onClick={() => navigate("/collections")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-purple-600 text-purple-50 hover:font-[600] hover:tracking-widest hover:text-purple-600 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Collections Report
              </button>
              <button
                onClick={() => navigate("/cash/cash_count")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Cash In Hand
              </button>
              <button
                onClick={() => navigate("/reports/my_stamp_duty")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-emerald-600 text-emerald-50 hover:font-[600] hover:tracking-widest hover:text-emerald-600 hover:bg-emerald-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                My Stamp Duty
              </button>
              <button
                onClick={() => navigate("/loans")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Loans
              </button>
              <button
                onClick={() => navigate("/customers/overview")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-lime-600 text-lime-50 hover:font-[600] hover:tracking-widest hover:text-lime-600 hover:bg-lime-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Manage Customers
              </button>
              <button
                onClick={() => navigate("/claims")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Make A Claim
              </button>
              <button
                onClick={() => navigate("/reports/cash_flow")}
                className="mt-[1rem] flex justify-center items-center space-x-2 bg-orange-600 text-orange-50 hover:font-[600] hover:tracking-widest hover:text-orange-600 hover:bg-orange-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black px-[1rem] py-[0.5rem] rounded w-[100%]">
                Cash Flow
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      {/* change password User Modal */}
      <Modal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[80%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Update User Password</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="oldPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Current Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPass((prevState) => ({
                        ...prevState,
                        current_password: e.target.value,
                      }))
                    }
                    value={editPass?.current_password}
                    type="text"
                    id="oldPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Current Password"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="newPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">New Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPass((prevState) => ({
                        ...prevState,
                        new_password: e.target.value,
                      }))
                    }
                    value={editPass?.new_password}
                    type="text"
                    id="newPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User New Password"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="confirmNewPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Confirm Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPass((prevState) => ({
                        ...prevState,
                        confirm_password: e.target.value,
                        _id: userDataFromStorage?._id,
                      }))
                    }
                    value={editPass?.confirm_password}
                    type="text"
                    id="confirmNewPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Confirm New Password"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setPasswordModalOpen(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={updatePasswordByAdminHandler}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Home;
